export const outwardFormData = () => ({
  inputData: {
    project_id: null,
    customer_id: null,
    warehouse_id: null,
    contractor_id: null,
    vehical_no: null,
    outward_date: null,
    remark: null,
    location: null,
    created_by: 1,
    is_active: true,
    type: "Outward",

    outward_items: [],
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "outwards",
    whereCondition: {
      is_active: true,
    },
    relation: [
      {
        modelName: "outward_items",
        moduleAs: "outward_items",
        foreignKey: "outward_id",
      },
    ],
    whereCondition: {
      type: "Scrab",
      project_id: 32,
      contractor_id: 1,
    },
  };

  const navigatePage = { back: "/mrb-approval-list" };

  const headerName = "Outward";

  const validationType = "OutwardCreate";
  const createEndpoint = "/createOutward";
  const getEndpoint = "/getOutwardById";
  const typeSelectOptions = [
    { label: "Outward", value: "Outward" },
    { label: "MRB", value: "MRB" },
    { label: "Scrab", value: "Scrab" },
  ];
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    getEndpoint,
    typeSelectOptions,
  };
};

export const exportPageData = {
  data: {
    modelName: "outwards",
    relations: [
      { module: "projects", moduleAs: "project" },
      { module: "user_masters", moduleAs: "customer" },
      { module: "warehouse_masters", moduleAs: "warehouse" },
      { module: "user_masters", moduleAs: "contractor" },
      { module: "user_masters", moduleAs: "createdBy" },
    ],
    search: {
      searchKeyword: "",
      field_name: ["warehouse.warehouse_name", "contractor.first_name"],
    },
    pagination: { page: 1, pageSize: 100000 },
  },
  fileName: "MRBApprovalData.xlsx",
};
